import API from '@/api/park/contract';
export default {
  methods: {
    // 按钮处理事件
    btnHandler(name) {
      this[name]();
    },
    // 获取页面表单表格数据
    async getDetailData() {
      // 1.表单数据
      const baseFormData = await this.$refs.baseInfoFormRef.getValidateFormData();
      console.log(baseFormData, '获取到的基本信息1');
      baseFormData.adminFlag = this.userInfo.adminFlag;
      // 2.仓储费率行信息
      const { tableData: expenseList } = await this.$refs.warehouseCostTable.getValidateTableData();
      console.log(expenseList, '仓储费率行信息');
      // 3.装卸费率行信息
      const { tableData: rateList } = await this.$refs.LoadCostTable.getValidateTableData();
      console.log(rateList, '装卸费率行信息');
      // 4.特殊费用项信息
      const { tableData: specialList } = await this.$refs.SpecialCostTable.getValidateTableData();
      console.log(specialList, '特殊费用项信息');
      // 5.附件
      const attachments = this.$refs.fileTableRef.getTableData();
      console.log(attachments, '上传的附件');
      /* // 6.审批数据
      const approvalList =  */
      const postData = {
        ...baseFormData,
        specialList,
        rateList,
        expenseList,
        attachments,
      };
      return postData;
    },
    // 保存处理事件
    save() {
      this.saveOrSubmitHandler(0);
    },
    // 提交处理事件
    submit() {
      this.saveOrSubmitHandler(1);
    },
    // 将商品类型数组转换为字符串
    goodsTypeCodeToString(val) {
      let goodsTypeCode = '';
      if (val && val.length && Array.isArray(val)) {
        val.forEach((element) => {
          goodsTypeCode += element + ',';
        });
      }
      goodsTypeCode = goodsTypeCode.substring(0, goodsTypeCode.length - 1);
      return goodsTypeCode;
    },
    // 将商品品类数组转换为字符串
    goodsCategoryCodeToString(val) {
      console.log(val, '将商品品类数组转换为字符串');
      let goodsCategoryCode = '';
      if (val && val.length && Array.isArray(val)) {
        val.forEach((element) => {
          goodsCategoryCode += element + ',';
        });
      }
      goodsCategoryCode = goodsCategoryCode.substring(0, goodsCategoryCode.length - 1);
      return goodsCategoryCode;
    },
    // 提交或者保存处理事件，operateFlag 0保存,1提交
    async saveOrSubmitHandler(type) {
      let isChangeInfor = 0;
      if (this.pageMode == '04') {
        isChangeInfor = 1;
      }
      const tableData = await this.getDetailData();
      console.log('tableData', tableData);
      tableData.goodsCategoryCode = this.goodsCategoryCodeToString(tableData.goodsCategoryCode);
      tableData.goodsTypeCode = this.goodsTypeCodeToString(tableData.goodsTypeCode);
      if (
        typeof tableData.goodsCategoryName == 'object' ||
        typeof tableData.goodsTypeName == 'object'
      ) {
        tableData.goodsCategoryName = this.goodsCategoryCodeToString(tableData.goodsCategoryName);
        tableData.goodsTypeName = this.goodsTypeCodeToString(tableData.goodsTypeName);
      }
      console.log(tableData, '获取到的基本信息2');
      const postData = { ...tableData, type, isChangeInfor };
      console.log('chuandizhipostData', postData);
      if (this.pageMode == 3 || this.isCopy == true) {
        postData.expenseList.forEach((item) => {
          delete item.contractId;
        });
        postData.rateList.forEach((item) => {
          delete item.contractId;
        });
        postData.specialList.forEach((item) => {
          delete item.contractId;
        });
        delete postData.id;
        delete postData.contractNo;
      }
      if (!postData) return;
      if (
        postData.expenseList.length < 1 &&
        postData.rateList.length < 1 &&
        postData.specialList.length < 1
      ) {
        this.$message.error('请至少填写一行费率信息！');
        return;
      }
      const {
        data: { code, msg },
      } = await this.$axios.post(API.SAVE_CONTRACT, {
        ...postData,
        businessDepartmentCode: this.userInfo.departmentCode,
        departmentCode: this.userInfo.departmentCode,
        companyCode: this.userInfo.companyCode,
      });
      if (code === 0) {
        this.$message.success(msg);
        this.closeCurrentAndToList();
      } else {
        this.$message.error(msg);
      }
    },
    // 通过审批处理事件
    pass() {
      this.approvalOrRejectHandlerByNo(true);
    },
    // 驳回审批处理事件
    refuse() {
      this.approvalOrRejectHandlerByNo(false);
    },
    // 提交审批
    async approvalOrRejectHandlerByNo(reviewFlag) {
      const baseFormData = await this.$refs.contractApprovalForm.getTableData();
      const postData = {
        ...baseFormData, // 表单表格数据
        reviewFlag,
        changeDate: this.userInfo.departmentName,
        operatorName: this.userInfo.userName,
        id: this.$route.query.id,
        contractId: this.$route.query.id,
        contractNo: this.contractNo,
        companyCode: this.userInfo.companyCode,
        companyName: this.userInfo.companyName,
        departmentName: this.userInfo.departmentName,
      };
      console.log(postData, 'postData');
      const { data } = await this.$axios.post(API.APPROVAL_CONTRACT, postData);
      console.log(data, '接口响应值');
      if (data.code == 0) {
        this.$message.success(data.msg);
        this.closeCurrentAndToList();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 取消处理事件
    cancel() {
      this.closeCurrentAndToList();
    },
    // 关闭tab栏并跳转到列表页
    closeCurrentAndToList() {
      let path = '';
      let name = '';
      const pageMode = this.$route.query.pageMode;
      if (pageMode == 0) {
        path = '/park/warehouse/contractMaintainance';
        name = 'contractMaintainance';
      } else if (pageMode == 1) {
        path = '/park/warehouse/contractDetail';
        name = 'contractDetail';
      } else if (pageMode == 2) {
        path = '/park/warehouse/contractApprove';
        name = 'contractApprove';
      } else if (pageMode == 3) {
        path = '/park/warehouse/contractRenew';
        name = 'contractRenew';
      } else if (pageMode == 4) {
        path = '/park/warehouse/contractChange';
        name = 'contractChange';
      } else if (pageMode == 5) {
        path = '/park/warehouse/contractClose';
        name = 'contractClose';
      }
      // 关闭当前tab导航
      this.$store.dispatch('tagsView/delView', {
        path,
        name,
        meta: {
          keepAlive: true,
          title: '',
        },
        query: {},
      });
      this.$router.push({
        path: '/park/warehouse/contractList',
        meta: {
          keepAlive: true,
          title: '合同列表',
        },
      });
    },
    // 关闭处理事件
    close() {
      this.$refs.closeContractRef.openDialog();
    },
    // 编辑处理事件
    edit() {
      this.disableButtons = false;
      this.showTableBtn = true;
      this.isDisabledForm = false;
      this.isDisabled = false;
      this.isDisabledDelete = false;
      this.isDisabledUpload = false;
    },
    // 续签
    renew() {
      let path = {
        path: 'warehouse/contractRenew',
        name: 'contractRenew',
        meta: {
          keepAlive: true,
          title: '合同续签',
        },
        query: {
          pageMode: 3,
          id: this.$route.query?.id,
        },
      };
      this.$router.push(path);
    },
    // 变更主体
    changeSubject() {
      this.$refs.changeSubjectRef.openDialog();
    },
    //变更合同信息
    changeContract() {
      let path = {
        path: 'warehouse/contractChange',
        name: 'contractChange',
        meta: {
          keepAlive: true,
          title: '合同信息变更',
        },
        query: {
          pageMode: 4,
          id: this.$route.query?.id,
        },
      };
      this.$router.push(path);
    },
  },
};
